import { render, staticRenderFns } from "./OccupationCard.vue?vue&type=template&id=4a6c162a&scoped=true"
import script from "./OccupationCard.vue?vue&type=script&lang=js"
export * from "./OccupationCard.vue?vue&type=script&lang=js"
import style0 from "./OccupationCard.vue?vue&type=style&index=0&id=4a6c162a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c162a",
  null
  
)

export default component.exports